// Dynamic sold-out gating for <rush-personalization> (see snippets/rush-personalization.liquid
// for the matching SSR `hidden` gate). Kept as its own asset because assets/custom.js
// (RushPersonalization's home) is frozen until native-personalizer P5.2 (repo CLAUDE.md).
// Bundle PDPs are skipped: each bundle component has its own variant picker and there is no
// single "current variant" to key off; the bundle's own sold-out signal is handled server-side
// only (snippets/product-bundle-components.liquid's bundle_sold_out).
(function () {
  if (window.__rushAvailabilityWired) return;
  window.__rushAvailabilityWired = true;

  document.addEventListener('theme:variant:change', (event) => {
    if (!event.target) return;
    const variant = event.detail && event.detail.variant;
    let available = !!(variant && variant.available);

    // Since the no-default-size change, an incomplete selection intentionally emits
    // `variant: null` while keeping Add to Cart enabled for required-field validation.
    // That is not a sold-out state. The theme updates the button before firing this
    // event, so its disabled state cleanly distinguishes an incomplete selection from
    // a fully selected but unavailable combination.
    if (!variant) {
      const addToCart = event.target.querySelector('[data-add-to-cart]');
      available = !!(addToCart && !addToCart.disabled);
    }

    document.querySelectorAll('rush-personalization').forEach((el) => {
      if (el.closest('product-bundle')) return;
      if (!event.target.contains(el)) return;
      el.hidden = !available;
    });
  });
})();
